import { render, staticRenderFns } from "./language-panel.vue?vue&type=template&id=11e788d7"
import script from "./language-panel.vue?vue&type=script&lang=ts"
export * from "./language-panel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports